export default "__VITE_ASSET__BtS_$1U4__"